export const sanitizeString = (value: string): string => value.replace(/[^ -~]/g, '');
